/*
 * @Author: 卫生健康文职会员中心
 * @Date: 2023-11-03 09:30:34
 * @LastEditTime: 2023-11-03 15:49:43
 */

export default [
  {
    path: "/wl-member",
    name: "wlMemberCenter",
    component: resolve => require(["@/views/wl-member/index"], resolve),
    meta: {
      title: "卫生健康文联"
    },
    redirect: "/wl-member/member",
    children: [
      // Tab主页-会员中心介绍
      {
        path: "member",
        name: "member",
        component: resolve => require(["@/views/wl-member/member"], resolve),
        meta: {
          title: "卫生健康文联"
        }
      },
      // Tab主页-作品欣赏
      {
        path: "creation",
        name: "creation",
        component: resolve => require(["@/views/wl-member/creation"], resolve),
        meta: {
          title: "卫生健康文联"
        }
      },
      // Tab主页-新闻
      {
        path: "news",
        name: "news",
        component: resolve => require(["@/views/wl-member/news"], resolve),
        meta: {
          title: "卫生健康文联"
        }
      },

      /** 子页面 - 会员入会 */
      // 入会章程介绍
      {
        path: "memberConst",
        name: "memberConst",
        component: resolve =>
          require(["@/views/wl-member/memberConst"], resolve),
        meta: {
          title: "卫生健康文联"
        }
      },
      // 入会申请说明
      {
        path: "memberIndex",
        name: "memberIndex",
        component: resolve =>
          require(["@/views/wl-member/memberIndex"], resolve),
        meta: {
          title: "卫生健康文联"
        }
      },
      // 会员申请表单
      {
        path: "memberApp",
        name: "memberApp",
        component: resolve => require(["@/views/wl-member/memberApp"], resolve),
        meta: {
          title: "卫生健康文联"
        }
      },
      // 申请结果
      {
        path: "memberStep",
        name: "memberStep",
        component: resolve =>
          require(["@/views/wl-member/memberStep"], resolve),
        meta: {
          title: "卫生健康文联"
        }
      },

      /** 子页面 - 作品 */
      // 作品列表
      {
        path: "creationList",
        name: "wl-creation-list",
        component: resolve =>
          require(["@/views/wl-member/creation-list"], resolve),
        meta: {
          title: "作品鉴赏"
        }
      },

      /** 子页面 - 新闻 */
      // 新闻详情
      {
        path: "newsDetail",
        name: "member-newsDetail",
        component: resolve =>
          require(["@/views/wl-member/newsDetail"], resolve),
        meta: {
          title: "详情"
        }
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/wl-member.js